// Tiny global pub/sub so any CTA can open the Book & Pay dialog.
const EVENT = "onevision:open-booking";

export function openBooking(service) {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { service } }));
}

export function onOpenBooking(handler) {
  const fn = (e) => handler(e.detail?.service);
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
}

// Load Razorpay checkout script once.
export function loadRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}
